import { render, staticRenderFns } from "./BenefitsSection.vue?vue&type=template&id=1285c192&scoped=true"
import script from "./BenefitsSection.vue?vue&type=script&lang=ts"
export * from "./BenefitsSection.vue?vue&type=script&lang=ts"
import style0 from "./BenefitsSection.vue?vue&type=style&index=0&id=1285c192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1285c192",
  null
  
)

export default component.exports